import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "absolute inset-0 z-[1000] flex justify-center bg-[rgba(255,255,255,0.4)]"
}
const _hoisted_2 = { class: "mt-20" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "flex w-full items-center justify-center" }
const _hoisted_6 = { class: "flex w-full items-center justify-center" }
const _hoisted_7 = { class: "flex w-full items-center justify-center" }
const _hoisted_8 = { class: "flex w-full items-center justify-center" }
const _hoisted_9 = { class: "flex w-full items-center justify-center" }
const _hoisted_10 = {
  key: 0,
  class: "flex w-full items-center justify-center"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "flex w-full items-center justify-center" }
const _hoisted_13 = { class: "flex w-full items-center justify-center" }
const _hoisted_14 = { class: "flex w-full items-center justify-center" }
const _hoisted_15 = { class: "flex w-full items-center justify-center" }
const _hoisted_16 = { class: "flex w-full items-center justify-center" }
const _hoisted_17 = { class: "flex w-full items-center justify-center" }
const _hoisted_18 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_19 = { key: 2 }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { key: 1 }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 0,
  class: "flex w-full justify-center"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "flex items-center space-x-2 font-bold" }
const _hoisted_39 = { class: "space-y-2" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "space-y-2 divide-y divide-dark" }
const _hoisted_42 = { class: "pt-2" }
const _hoisted_43 = { class: "divide-y divide-gray-300" }
const _hoisted_44 = { class: "py-2" }
const _hoisted_45 = { class: "space-y-2" }
const _hoisted_46 = { class: "space-y-2 divide-y divide-gray-300" }
const _hoisted_47 = { class: "flex items-center justify-between pt-2 first:pt-0" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "grid w-full grid-cols-2" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = { key: 0 }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { key: 1 }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { key: 1 }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = { key: 2 }
const _hoisted_65 = { key: 1 }
const _hoisted_66 = ["onClick"]
const _hoisted_67 = ["onClick"]
const _hoisted_68 = ["title"]
const _hoisted_69 = ["title"]
const _hoisted_70 = ["title"]
const _hoisted_71 = { key: 0 }
const _hoisted_72 = { key: 1 }
const _hoisted_73 = { class: "flex items-center justify-center" }
const _hoisted_74 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_small_loader = _resolveComponent("small-loader")!
  const _component_dx_column = _resolveComponent("dx-column")!
  const _component_DxOperationDescriptions = _resolveComponent("DxOperationDescriptions")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxGrouping = _resolveComponent("DxGrouping")!
  const _component_DxGroupPanel = _resolveComponent("DxGroupPanel")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_dx_column_chooser = _resolveComponent("dx-column-chooser")!
  const _component_dx_texts = _resolveComponent("dx-texts")!
  const _component_dx_export = _resolveComponent("dx-export")!
  const _component_dx_group_panel = _resolveComponent("dx-group-panel")!
  const _component_dx_search_panel = _resolveComponent("dx-search-panel")!
  const _component_dx_pager = _resolveComponent("dx-pager")!
  const _component_dx_paging = _resolveComponent("dx-paging")!
  const _component_dx_selection = _resolveComponent("dx-selection")!
  const _component_dx_header_filter = _resolveComponent("dx-header-filter")!
  const _component_dx_item = _resolveComponent("dx-item")!
  const _component_dx_toolbar = _resolveComponent("dx-toolbar")!
  const _component_dx_drop_down_button = _resolveComponent("dx-drop-down-button")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_dropdown_menu = _resolveComponent("dropdown-menu")!
  const _component_TheButton = _resolveComponent("TheButton")!
  const _component_DxTotalItem = _resolveComponent("DxTotalItem")!
  const _component_DxSummary = _resolveComponent("DxSummary")!
  const _component_dx_data_grid = _resolveComponent("dx-data-grid")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createBlock(_component_dx_data_grid, {
    id: "devextreme-table",
    ref: "devextremeTable",
    "filter-value": _ctx.test,
    "onUpdate:filterValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.test) = $event)),
    "allow-column-reordering": true,
    "allow-column-resizing": true,
    "column-auto-width": _ctx.allowAutoResize,
    "data-source": _ctx.tableData,
    height: _ctx.tableHeight && _ctx.tableHeight,
    "hover-state-enabled": true,
    "remote-operations": false,
    "row-alternation-enabled": false,
    "show-borders": true,
    "show-row-lines": true,
    "selected-row-keys": _ctx.selectedRowKeys,
    class: "relative",
    width: "100%",
    "show-scrollbar": "always",
    onExporting: _ctx.onExporting,
    onSelectionChanged: _ctx.onSelectionChanged,
    onRowPrepared: _ctx.onRowPrepared,
    onContentReady: _ctx.onContentReady,
    onRowClick: _ctx.rowClick,
    onCellPrepared: _ctx.onCellPrepared,
    onEditingStart: _ctx.onEditingStart,
    onRowUpdating: _ctx.onRowUpdating,
    onRowUpdated: _ctx.onRowUpdated
  }, {
    usersDeviceIsSharedTo: _withCtx(({ data }) => [
      _createElementVNode("p", {
        class: "cursor-pointer underline",
        onClick: ($event: any) => (_ctx.$emit('users-device-is-shared-to', data.data.assignmentId))
      }, " See users ", 8, _hoisted_3)
    ]),
    usersRejectApproveShare: _withCtx(({ data }) => [
      _createElementVNode("p", {
        class: "cursor-pointer underline",
        onClick: ($event: any) => (_ctx.$emit('users-device-is-pending', data.data.assignmentId))
      }, " See users ", 8, _hoisted_4)
    ]),
    actionsTemplate: _withCtx(() => [
      _createVNode(_component_dx_drop_down_button, {
        "drop-down-options": { width: 250 },
        items: _ctx.actionsOptions,
        text: "Action",
        onItemClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('action-click', $event)))
      }, null, 8, ["items"])
    ]),
    isActive: _withCtx(({ data }) => [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(`h-3 w-3 rounded-full ${data.data.isActive ? 'bg-success' : 'bg-error'}`)
        }, null, 2)
      ])
    ]),
    isCompanyActive: _withCtx(({ data }) => [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass(`h-3 w-3 rounded-full ${data.data.isCompanyActive ? 'bg-success' : 'bg-error'}`)
        }, null, 2)
      ])
    ]),
    isProductionEnabled: _withCtx(({ data }) => [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: _normalizeClass(`h-3 w-3 rounded-full ${data.data.isProductionEnabled ? 'bg-success' : 'bg-error'}`)
        }, null, 2)
      ])
    ]),
    active: _withCtx(({ data }) => [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: _normalizeClass(`h-3 w-3 rounded-full ${data.data.active ? 'bg-success' : 'bg-error'}`)
        }, null, 2)
      ])
    ]),
    isSent: _withCtx(({ data }) => [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: _normalizeClass(`h-3 w-3 rounded-full ${data.data.isSent ? 'bg-success' : 'bg-error'}`)
        }, null, 2)
      ])
    ]),
    occupied: _withCtx(({ data }) => [
      (typeof data.data.occupied === 'boolean')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass(`h-3 w-3 rounded-full ${data.data.occupied ? 'bg-error' : 'bg-success'} ${_ctx.isMinDate(data.data?.occupiedTimestamp) ? '!bg-slate-400' : ''
          }`)
            }, null, 2)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(data.data.occupied), 1))
    ]),
    visible: _withCtx(({ data }) => [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", {
          class: _normalizeClass(`h-3 w-3 rounded-full ${data.data.visible ? 'bg-success' : 'bg-error'}`)
        }, null, 2)
      ])
    ]),
    public: _withCtx(({ data }) => [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", {
          class: _normalizeClass(`h-3 w-3 rounded-full ${data.data.public ? 'bg-success' : 'bg-error'}`)
        }, null, 2)
      ])
    ]),
    integration: _withCtx(({ data }) => [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", {
          class: _normalizeClass(`h-3 w-3 rounded-full ${data.data.integration ? 'bg-success' : 'bg-error'}`)
        }, null, 2)
      ])
    ]),
    navigable: _withCtx(({ data }) => [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", {
          class: _normalizeClass(`h-3 w-3 rounded-full ${data.data.navigable ? 'bg-success' : 'bg-error'}`)
        }, null, 2)
      ])
    ]),
    refurbished: _withCtx(({ data }) => [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", {
          class: _normalizeClass(`h-3 w-3 rounded-full ${data.data.refurbished ? 'bg-success' : 'bg-error'}`)
        }, null, 2)
      ])
    ]),
    spotOccupied: _withCtx(({ data }) => [
      _createElementVNode("div", _hoisted_17, [
        (data.data.spotOccupied !== null && !data.data.firmwareUpdateStatus)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(`h-3 w-3 rounded-full ${data.data.lastSync !== null
            ? _ctx.syncDifferenceTime({
              hours: 72,
              lastSyncTime: data.data.lastSync,
            })
              ? 'bg-slate-400'
              : data.data.spotOccupied
                ? 'bg-error'
                : 'bg-success'
            : 'bg-slate-400'
          }`)
            }, null, 2))
          : (data.data.firmwareUpdateStatus)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, "FW UPDATE"))
            : (_openBlock(), _createElementBlock("div", _hoisted_19, "-"))
      ])
    ]),
    lastTimeDeviceSentData: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: _normalizeClass(`${_ctx.syncDifferenceTime({
        hours: data.data.nodes ? 24 : 72,
        lastSyncTime: data.data.lastTimeDeviceSentData,
      }) === null
          ? 'text-darkgrey'
          : _ctx.syncDifferenceTime({
            hours: data.data.nodes ? 24 : 72,
            lastSyncTime: data.data.lastTimeDeviceSentData,
          })
            ? 'text-error'
            : 'text-success'
        }`)
      }, _toDisplayString(_ctx.formatDateTime(data.data.lastTimeDeviceSentData)), 3)
    ]),
    createdAt: _withCtx(({ data }) => [
      _createElementVNode("p", null, _toDisplayString(_ctx.formatDateTimeSeconds(data.data.createdAt)), 1)
    ]),
    date: _withCtx(({ data }) => [
      _createElementVNode("p", null, _toDisplayString(_ctx.formatDateTimeSeconds(data.data.date)), 1)
    ]),
    updatedAt: _withCtx(({ data }) => [
      _createElementVNode("p", null, _toDisplayString(_ctx.formatDateTimeSeconds(data.data.updatedAt)), 1)
    ]),
    policyValidFrom: _withCtx(({ data }) => [
      _createElementVNode("p", null, _toDisplayString(_ctx.formatDateTime(data.data.policyValidFrom)), 1)
    ]),
    policyValidTo: _withCtx(({ data }) => [
      _createElementVNode("p", null, _toDisplayString(_ctx.formatDateTime(data.data.policyValidTo)), 1)
    ]),
    dateTime: _withCtx(({ data }) => [
      _createTextVNode(_toDisplayString(_ctx.formatDateTimeSeconds(data.data.dateTime)), 1)
    ]),
    text: _withCtx(({ data }) => [
      _createTextVNode(_toDisplayString(data.data.payload != undefined ? data.data.payload.text : data.data.text), 1)
    ]),
    start: _withCtx(({ data }) => [
      _createTextVNode(_toDisplayString(_ctx.formatDateTimeSeconds(data.data.start)), 1)
    ]),
    end: _withCtx(({ data }) => [
      _createTextVNode(_toDisplayString(_ctx.formatDateTimeSeconds(data.data.end)), 1)
    ]),
    durationMinutes: _withCtx(({ data }) => [
      _createTextVNode(_toDisplayString(_ctx.convertMinutesToHoursAndMinutesFormatted(data.data.durationMinutes)), 1)
    ]),
    icdCustomerName: _withCtx(({ data }) => [
      _createTextVNode(_toDisplayString(data.data.icdCustomerName), 1)
    ]),
    payload: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: "cursor-pointer text-primary hover:underline",
        onClick: ($event: any) => (_ctx.$emit('open-data-modal', data.data))
      }, _toDisplayString(JSON.stringify(data.data.payload)), 9, _hoisted_20)
    ]),
    metadata: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: "cursor-pointer text-primary hover:underline",
        onClick: ($event: any) => (_ctx.$emit('open-data-modal', data.data.metadata))
      }, _toDisplayString(JSON.stringify(data.data.metadata)), 9, _hoisted_21)
    ]),
    assignmentApplication: _withCtx(({ data }) => [
      (data.data.assignment?.application?.name)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(data.data.assignment.application.name), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_23, "-"))
    ]),
    assignmentCompany: _withCtx(({ data }) => [
      (data.data.assignment?.company?.name)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(data.data.assignment.company.name), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_25, "-"))
    ]),
    assignmentUser: _withCtx(({ data }) => [
      (data.data.assignment?.user?.username)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(data.data.assignment.user.username), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_27, "-"))
    ]),
    assignmentMetadata: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: "cursor-pointer text-primary hover:underline",
        onClick: ($event: any) => (_ctx.$emit('open-data-modal', data.data.assignment.metadata))
      }, _toDisplayString(JSON.stringify(data.data.assignment.metadata)), 9, _hoisted_28)
    ]),
    metadataDevice: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: "cursor-pointer text-primary hover:underline",
        onClick: ($event: any) => (_ctx.$emit('open-data-modal', data.data.metadata))
      }, _toDisplayString(JSON.stringify(data.data.metadata)), 9, _hoisted_29)
    ]),
    data: _withCtx(({ data }) => [
      (data.data.data)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "cursor-pointer text-primary hover:underline",
            onClick: ($event: any) => (_ctx.$emit('open-data-modal', data.data))
          }, _toDisplayString(JSON.stringify(data.data.data)), 9, _hoisted_30))
        : (_openBlock(), _createElementBlock("div", _hoisted_31, "-"))
    ]),
    nodes: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: "cursor-pointer underline",
        onClick: ($event: any) => (_ctx.$emit('manage-nodes', { id: data.data.id, name: data.data.name }))
      }, _toDisplayString(_ctx.$t("Displays.ManageNodes")), 9, _hoisted_32)
    ]),
    manageNodes: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: "cursor-pointer underline",
        onClick: ($event: any) => (_ctx.$emit('manage-nodes', { id: data.data.id, name: data.data.name }))
      }, _toDisplayString(_ctx.$t("Displays.ManageNodes")), 9, _hoisted_33)
    ]),
    sources: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: "cursor-pointer underline",
        onClick: ($event: any) => (_ctx.$emit('manage-sources', { id: data.data.id, index: data.data.index }))
      }, _toDisplayString(_ctx.$t("Displays.ManageSources")), 9, _hoisted_34)
    ]),
    goToDetails: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: "flex w-full cursor-pointer items-center justify-center text-center text-gray-600",
        onClick: ($event: any) => (_ctx.changeRoute(data.data))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'angle-right'] })
      ], 8, _hoisted_35)
    ]),
    deviceActions: _withCtx(({ data }) => [
      (data.data?.actions?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _createVNode(_component_the_button, {
              "button-type": "small-primaryButton",
              text: "Actions",
              onExecuteMethod: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggle-static-actions-modal')))
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    openMenu: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: "relative flex h-full w-full cursor-pointer items-center justify-center text-center text-gray-600",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDropdownOpenedFromOutside = !_ctx.isDropdownOpenedFromOutside))
      }, [
        _createVNode(_component_dropdown_menu, {
          options: _ctx.options,
          assetPermissions: data.data.assignment?.permissions || data.data.resourcePermissions,
          isCompanyActive: data.data.isCompanyActive,
          "remove-edit": data.data.isApplied,
          "use-for-table": true
        }, null, 8, ["options", "assetPermissions", "isCompanyActive", "remove-edit"])
      ])
    ]),
    openViewData: _withCtx(({ data }) => [
      (!_ctx.moduleToggleStore.isDevelopment)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "relative flex h-full w-full cursor-pointer items-center justify-center text-center text-gray-600",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isDropdownOpenedFromOutside = !_ctx.isDropdownOpenedFromOutside))
          }, [
            _createVNode(_component_TheButton, {
              text: 'View',
              size: "sm",
              onClick: ($event: any) => (
          _ctx.$emit('openGenericPacketModal', {
            data: data.row.data,
            removeEdit: data.data.isApplied,
          })
          ),
              variant: data.row.data.lastTimeDeviceSentData ? 'default' : 'ghost',
              "is-disabled": data.row.data.lastTimeDeviceSentData ? false : true
            }, null, 8, ["onClick", "variant", "is-disabled"])
          ]))
        : _createCommentVNode("", true)
    ]),
    allResponseMessages: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: "cursor-pointer underline",
        onClick: ($event: any) => (_ctx.$emit('view-messages', { id: data.data.id }))
      }, _toDisplayString(_ctx.$t("ResponseMessages.Title")), 9, _hoisted_37)
    ]),
    days: _withCtx(({ data }) => [
      _createElementVNode("div", _hoisted_38, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.data.days, (value, key, index) => {
          return (_openBlock(), _createElementBlock("p", {
            class: _normalizeClass(`${value ? 'text-success' : 'text-error'}`)
          }, _toDisplayString(_ctx.days[Number(index)]), 3))
        }), 256))
      ])
    ]),
    minutesToHoursFrom: _withCtx(({ data }) => [
      _createElementVNode("div", null, _toDisplayString(_ctx.convertMinutesToHoursAndMinutes(data.data.fromMinutes)), 1)
    ]),
    minutesToHoursTo: _withCtx(({ data }) => [
      _createElementVNode("div", null, _toDisplayString(_ctx.convertMinutesToHoursAndMinutes(data.data.toMinutes)), 1)
    ]),
    occupiedTimestamp: _withCtx(({ data }) => [
      _createElementVNode("div", null, _toDisplayString(_ctx.formatDateTimeSeconds(data.data.occupiedTimestamp)), 1)
    ]),
    utcTimestamp: _withCtx(({ data }) => [
      _createElementVNode("div", null, _toDisplayString(_ctx.formatDateTimeSeconds(data.data.utcTimestamp)), 1)
    ]),
    dateTimeEvent: _withCtx(({ data }) => [
      _createElementVNode("div", null, _toDisplayString(_ctx.formatDateTimeSeconds(data.data.dateTimeEvent)), 1)
    ]),
    lastSync: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: _normalizeClass(`${_ctx.syncDifferenceTime({
        hours: data.data.nodes ? 24 : 72,
        lastSyncTime: data.data.lastSync,
      }) === null
          ? 'text-darkgrey'
          : _ctx.syncDifferenceTime({
            hours: data.data.nodes ? 24 : 72,
            lastSyncTime: data.data.lastSync,
          })
            ? 'text-error'
            : 'text-success'
        }`)
      }, _toDisplayString(_ctx.formatDateTimeSeconds(data.data.lastSync)), 3)
    ]),
    rssi: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: _normalizeClass(`${_ctx.rssiHealth({ signal: data.data.rssi })}`)
      }, _toDisplayString(data.data.rssi), 3)
    ]),
    refresh: _withCtx(({ data }) => [
      _createElementVNode("div", null, _toDisplayString(_ctx.isMinDate(data.data.refresh) ? "-" : _ctx.formatDateTime(data.data.refresh)), 1)
    ]),
    rtc: _withCtx(({ data }) => [
      _createElementVNode("div", null, _toDisplayString(_ctx.isMinDate(data.data.rtc) ? "-" : _ctx.formatDateTimeSeconds(data.data.rtc)), 1)
    ]),
    storedAt: _withCtx(({ data }) => [
      _createElementVNode("div", null, _toDisplayString(_ctx.formatDateTimeSeconds(data.data.storedAt)), 1)
    ]),
    dateCreate: _withCtx(({ data }) => [
      _createElementVNode("div", null, _toDisplayString(_ctx.formatDateTimeSeconds(data.data.dateCreate)), 1)
    ]),
    accesses: _withCtx(({ data }) => [
      _createElementVNode("div", _hoisted_39, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.data?.accesses, (access) => {
          return (_openBlock(), _createElementBlock("div", null, [
            (access.action !== 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(access?.resourceName) + ": " + _toDisplayString(_ctx.formatDateTime(access?.dateActiveFrom)) + " - " + _toDisplayString(_ctx.formatDateTime(access?.dateActiveTo)) + " (" + _toDisplayString(access?.active ? "Active" : "Not active") + ") ", 1))
              : _createCommentVNode("", true)
          ]))
        }), 256))
      ])
    ]),
    authResources: _withCtx(({ data }) => [
      _createElementVNode("div", _hoisted_41, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.data.authResources, (authResource) => {
          return (_openBlock(), _createElementBlock("div", null, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_42, [
                _cache[6] || (_cache[6] = _createTextVNode(" Resource: ", -1)),
                _createElementVNode("b", null, _toDisplayString(authResource.onResourceName || "All resources"), 1)
              ]),
              _createElementVNode("p", null, " Valid: " + _toDisplayString(_ctx.formatDateTimePolicy(authResource.policyValidFrom)) + " - " + _toDisplayString(_ctx.formatDateTimePolicy(authResource.policyValidTo)), 1),
              _createElementVNode("p", null, "Created by: " + _toDisplayString(authResource.createdUserEmail), 1)
            ])
          ]))
        }), 256))
      ])
    ]),
    resources: _withCtx(({ data }) => [
      _createElementVNode("div", _hoisted_43, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.data.resources, (resource) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_44, [
            _createElementVNode("div", null, [
              _cache[7] || (_cache[7] = _createTextVNode(" Role: ", -1)),
              _createElementVNode("strong", null, _toDisplayString(resource.role.name), 1)
            ]),
            _createElementVNode("div", null, [
              _cache[8] || (_cache[8] = _createTextVNode(" Resource: ", -1)),
              _createElementVNode("strong", null, _toDisplayString(resource?.onResource.name), 1)
            ]),
            _createElementVNode("div", null, "Resource type: " + _toDisplayString(resource.resourceType.name), 1),
            _createElementVNode("div", null, "Created by: " + _toDisplayString(resource.createdUser.email), 1)
          ]))
        }), 256))
      ])
    ]),
    identifiers: _withCtx(({ data }) => [
      _createElementVNode("div", _hoisted_45, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.data?.identifiers, (identifier) => {
          return (_openBlock(), _createElementBlock("div", null, "RFID: " + _toDisplayString(identifier.value), 1))
        }), 256))
      ])
    ]),
    subscriptionItems: _withCtx(({ data }) => [
      _createElementVNode("div", _hoisted_46, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.data.subscriptionItems, (subscriptions) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_47, [
            _createElementVNode("p", null, _toDisplayString(subscriptions.name), 1),
            _createElementVNode("p", null, _toDisplayString(subscriptions.price) + " €", 1)
          ]))
        }), 256))
      ])
    ]),
    revokeAction: _withCtx(({ data }) => [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "group h-full w-full cursor-pointer text-center hover:bg-errorlight",
        onClick: ($event: any) => (_ctx.$emit('revoke-action', data.data.email))
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'xmark'],
          class: "text-xl group-hover:text-error"
        })
      ], 8, _hoisted_48)), [
        [_directive_tippy, 'Revoke device']
      ])
    ]),
    rejectApproveAction: _withCtx(({ data }) => [
      _createElementVNode("div", _hoisted_49, [
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "group flex w-full cursor-pointer justify-center hover:bg-errorlight",
          onClick: ($event: any) => (
            _ctx.$emit('reject-approve-action', {
              userEmail: data.data.email,
              status: 'reject',
            })
            )
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fas', 'xmark'],
            class: "text-xl group-hover:text-error"
          })
        ], 8, _hoisted_50)), [
          [_directive_tippy, 'Reject request']
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "group flex w-full cursor-pointer justify-center hover:bg-successlight",
          onClick: ($event: any) => (
            _ctx.$emit('reject-approve-action', {
              userEmail: data.data.email,
              status: 'approve',
            })
            )
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fas', 'check'],
            class: "text-xl group-hover:text-success"
          })
        ], 8, _hoisted_51)), [
          [_directive_tippy, 'Approve request']
        ])
      ])
    ]),
    packetsSentMerged: _withCtx(({ data }) => [
      _createElementVNode("p", {
        class: "cursor-pointer text-center underline hover:text-primary",
        onClick: ($event: any) => (_ctx.$emit('view-sensor-packets', data.data))
      }, _toDisplayString(data.data.packetsSentMerged), 9, _hoisted_52)
    ]),
    displayEventsReport: _withCtx(({ data }) => [
      _createElementVNode("p", {
        class: "cursor-pointer underline hover:text-primary",
        onClick: ($event: any) => (_ctx.$emit('view-display-events', data.data))
      }, _toDisplayString(data.data.displayEventsReport), 9, _hoisted_53)
    ]),
    spotAssignHistory: _withCtx(({ data }) => [
      _createElementVNode("p", {
        class: "cursor-pointer underline hover:text-primary",
        onClick: ($event: any) => (_ctx.$emit('spot-assign-history', data.data))
      }, _toDisplayString(_ctx.$t("Sensors.SpotAssignHistory")), 9, _hoisted_54)
    ]),
    unassign: _withCtx(({ data }) => [
      (data.data.unassign === 'Assigned')
        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
            _createElementVNode("p", {
              class: "cursor-pointer underline hover:text-primary",
              onClick: ($event: any) => (_ctx.$emit('unassign-icd-tag', data.data))
            }, _toDisplayString(_ctx.$t("ICDManagement.Unassign")), 9, _hoisted_56)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_57, [
            _createElementVNode("p", {
              class: "cursor-pointer underline hover:text-primary",
              onClick: ($event: any) => (_ctx.$emit('assign-icd-tag', data.data))
            }, _toDisplayString(_ctx.$t("ICDManagement.Assign")), 9, _hoisted_58)
          ]))
    ]),
    busControllerEventsReport: _withCtx(({ data }) => [
      _createElementVNode("p", {
        class: "cursor-pointer text-center underline hover:text-primary",
        onClick: ($event: any) => (_ctx.$emit('view-display-events', data.data))
      }, _toDisplayString(data.data.busControllerEventsReport), 9, _hoisted_59)
    ]),
    assignColumn: _withCtx(({ data }) => [
      _createElementVNode("p", {
        class: "cursor-pointer underline hover:text-primary",
        onClick: ($event: any) => (_ctx.$emit('assign-sensor', data.data))
      }, _toDisplayString(_ctx.$t("Sensors.AssignSensor")), 9, _hoisted_60)
    ]),
    isApplied: _withCtx(({ data }) => [
      (data.data.isApplied)
        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("p", null, "Applied", -1)
          ]))]))
        : _createCommentVNode("", true),
      (!data.data.isApplied && data.data.currentCount === data.data.pieces)
        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
            _createElementVNode("p", {
              class: "cursor-pointer underline",
              onClick: ($event: any) => (_ctx.$emit('apply', data.data.id))
            }, "Apply", 8, _hoisted_63)
          ]))
        : _createCommentVNode("", true),
      (!data.data.isApplied && data.data.currentCount < data.data.pieces)
        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [...(_cache[10] || (_cache[10] = [
            _createElementVNode("p", { class: "cursor-not-allowed text-gray-300" }, "Apply", -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    parkingState: _withCtx(({ data }) => [
      _createElementVNode("div", null, [
        (data.data.parkingState !== null && data.data.parkingState !== undefined)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass(`${data.data.parkingState === 0 ? 'text-success' : 'text-error'}`)
            }, _toDisplayString(data.data.parkingState === 0 ? "Unoccupied" : "Occupied"), 3))
          : (_openBlock(), _createElementBlock("p", _hoisted_65, "-"))
      ])
    ]),
    deleteWorkOrder: _withCtx(({ data }) => [
      _createElementVNode("p", {
        class: "cursor-pointer underline hover:text-error",
        onClick: ($event: any) => (_ctx.$emit('delete-work-order', data.data))
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'trash'],
          class: "pr-2"
        }),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("Action.Delete")), 1)
      ], 8, _hoisted_66)
    ]),
    sensorPackets: _withCtx(({ data }) => [
      _createElementVNode("p", {
        class: "cursor-pointer text-center underline hover:text-primary",
        onClick: ($event: any) => (_ctx.$emit('view-sensor-packets', data.data))
      }, " Packets ", 8, _hoisted_67)
    ]),
    batteryPercentage: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: _normalizeClass(`${data.data.batteryPercentage < 25 ? 'text-error' : 'text-black'}`)
      }, _toDisplayString(data.data.batteryPercentage), 3)
    ]),
    avgConsumptionPerDay: _withCtx(({ data }) => [
      _createElementVNode("div", {
        title: `${data.data.avgConsumptionPerDay}`,
        class: _normalizeClass(`${data.data.avgConsumptionPerDay > 15 ? 'text-error' : 'text-black'}`)
      }, _toDisplayString(data.data.avgConsumptionPerDay == null ? "-" : data.data.avgConsumptionPerDay.toFixed(2)), 11, _hoisted_68)
    ]),
    avgRssi: _withCtx(({ data }) => [
      _createElementVNode("div", {
        title: `${data.data.avgRssi}`,
        class: _normalizeClass(`${data.data.avgRssi < -110 ? 'text-error' : 'text-black'}`)
      }, _toDisplayString(data.data.avgRssi == null ? "-" : data.data.avgRssi.toFixed(0)), 11, _hoisted_69)
    ]),
    avgPacketsPerDay: _withCtx(({ data }) => [
      _createElementVNode("div", {
        title: `${data.data.avgPacketsPerDay}`,
        class: _normalizeClass(`${data.data.avgPacketsPerDay > 50 ? 'text-error' : 'text-black'}`)
      }, _toDisplayString(data.data.avgPacketsPerDay == null ? "-" : data.data.avgPacketsPerDay.toFixed(2)), 11, _hoisted_70)
    ]),
    notSequencePackets: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: _normalizeClass(`${data.data.notSequencePackets ? 'text-error' : 'text-black'}`)
      }, _toDisplayString(data.data.notSequencePackets ? "(at " + data.data.notSequencePacketsPoint + ")" : "-"), 3)
    ]),
    packetsNotIncrement: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: _normalizeClass(`${data.data.packetsNotIncrement ? 'text-error' : 'text-black'}`)
      }, _toDisplayString(data.data.packetsNotIncrement), 3)
    ]),
    lastUnhandledReboot: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: _normalizeClass(`${data.data.lastUnhandledReboot > 15 || data.data.lastUnhandledReboot < 0 ? 'text-error' : 'text-black'
        }`)
      }, _toDisplayString(data.data.lastUnhandledReboot), 3)
    ]),
    rebootsGrows: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: _normalizeClass(`${data.data.rebootsGrows ? 'text-error' : 'text-black'}`)
      }, _toDisplayString(data.data.rebootsGrows), 3)
    ]),
    rebootsNegative: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: _normalizeClass(`${data.data.rebootsNegative ? 'text-error' : 'text-black'}`)
      }, _toDisplayString(data.data.rebootsNegative), 3)
    ]),
    rebootsChangingError: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: _normalizeClass(`${data.data.rebootsChangingError ? 'text-error' : 'text-black'}`)
      }, _toDisplayString(data.data.rebootsChangingError), 3)
    ]),
    avgPowerOnCountPerDay: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: _normalizeClass(`${data.data.avgPowerOnCountPerDay > 350 || data.data.avgPowerOnCountPerDay < 250 ? 'text-error' : 'text-black'
        }`)
      }, _toDisplayString(data.data.avgPowerOnCountPerDay), 3)
    ]),
    runtimeTotalSecondsHealth: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: _normalizeClass(`${data.data.runtimeTotalSecondsHealth > 700 ? 'text-error' : 'text-black'}`)
      }, _toDisplayString(data.data.runtimeTotalSecondsHealth == 0
            ? "-"
            : Math.floor(data.data.runtimeTotalSecondsHealth / 60) + " min/day"), 3)
    ]),
    disableCounter: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: _normalizeClass(`${data.data.disableCounter ? 'text-error' : 'text-black'}`)
      }, _toDisplayString(data.data.disableCounter), 3)
    ]),
    eclTwo: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: _normalizeClass(`${data.data.eclTwo ? 'text-error' : 'text-black'}`)
      }, _toDisplayString(data.data.eclTwo), 3)
    ]),
    samePacketIdCounter: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: _normalizeClass(`${data.data.samePacketIdCounter > 0 ? 'text-error' : 'text-black'}`)
      }, _toDisplayString(data.data.samePacketIdCounter), 3)
    ]),
    mag1RawXFlash: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: _normalizeClass(`${data.data.mag1RawXFlash ? 'text-error' : 'text-black'}`)
      }, _toDisplayString(data.data.mag1RawXFlash), 3)
    ]),
    mag1RawYFlash: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: _normalizeClass(`${data.data.mag1RawYFlash ? 'text-error' : 'text-black'}`)
      }, _toDisplayString(data.data.mag1RawYFlash), 3)
    ]),
    mag1RawZFlash: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: _normalizeClass(`${data.data.mag1RawZFlash ? 'text-error' : 'text-black'}`)
      }, _toDisplayString(data.data.mag1RawZFlash), 3)
    ]),
    radarFlash: _withCtx(({ data }) => [
      _createElementVNode("div", {
        class: _normalizeClass(`${data.data.radarFlash ? 'text-error' : 'text-black'}`)
      }, _toDisplayString(data.data.radarFlash), 3)
    ]),
    commitHeader: _withCtx(({ data }) => [
      _createVNode(_component_the_button, {
        text: `Commit ${data.data.name}`,
        size: "full",
        onExecuteMethod: ($event: any) => (_ctx.$emit('commit-action', data.data.id))
      }, null, 8, ["text", "onExecuteMethod"])
    ]),
    responseMessage: _withCtx(({ data }) => [
      (data.data.responseMessages?.message)
        ? (_openBlock(), _createElementBlock("div", _hoisted_71, _toDisplayString(data.data.responseMessages.message), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_72, "-"))
    ]),
    tagName: _withCtx(({ data }) => [
      _createElementVNode("div", null, _toDisplayString(data.data.name), 1)
    ]),
    userRole: _withCtx(({ data }) => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.data.roles, (role) => {
        return (_openBlock(), _createElementBlock("div", {
          key: role.id
        }, _toDisplayString(role.name), 1))
      }), 128))
    ]),
    deviceTypeId: _withCtx(({ data }) => [
      _createElementVNode("div", _hoisted_73, [
        _createElementVNode("img", {
          src: _ctx.IconSelector(data.data.device.deviceTypeId),
          class: "h-auto w-10"
        }, null, 8, _hoisted_74)
      ])
    ]),
    time: _withCtx(({ data }) => [
      _createTextVNode(_toDisplayString(_ctx.formatDateTime(data.data.time)), 1)
    ]),
    default: _withCtx(() => [
      (!_ctx.showPerPage)
        ? (_openBlock(), _createBlock(_component_DxScrolling, {
            key: 0,
            mode: "virtual"
          }))
        : _createCommentVNode("", true),
      (_ctx.isDataSourceLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_small_loader, {
                height: "h-16",
                width: "w-16"
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isDevicesTable)
        ? (_openBlock(), _createBlock(_component_dx_column, {
            key: 2,
            caption: "",
            "cell-template": "deviceTypeId"
          }))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeaders, (headerValue, headerKey) => {
        return (_openBlock(), _createBlock(_component_dx_column, {
          key: headerKey,
          visible: headerValue['visible'],
          "onUpdate:visible": ($event: any) => ((headerValue['visible']) = $event),
          "allow-filtering": true,
          caption: _ctx.$t(headerValue['header']),
          "cell-template": _ctx.cellTemplateSelector(headerKey),
          "customize-text": _ctx.customizeText,
          "data-field": headerKey,
          "data-type": _ctx.columnDataTypeConverter(headerKey),
          "group-index": headerValue['groupIndex'],
          "sort-order": headerValue['sortOrder'],
          alignment: "left",
          width: headerKey === 'notSequencePackets' ? '180px' : undefined,
          allowEditing: headerValue['allowUpdateColumn'] === undefined ? false : headerValue['allowUpdateColumn']
        }, null, 8, ["visible", "onUpdate:visible", "caption", "cell-template", "customize-text", "data-field", "data-type", "group-index", "sort-order", "width", "allowEditing"]))
      }), 128)),
      (!_ctx.removeTableHeader)
        ? (_openBlock(), _createBlock(_component_DxFilterRow, {
            key: 3,
            "highlight-case-sensitive": false,
            visible: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxOperationDescriptions, {
                equal: _ctx.$t('DataGridFilter.Equal'),
                contains: _ctx.$t('DataGridFilter.Contains'),
                "not-equal": _ctx.$t('DataGridFilter.DoesNotEqual'),
                "less-than": _ctx.$t('DataGridFilter.LessThan'),
                "greater-than": _ctx.$t('DataGridFilter.GreaterThan'),
                "less-than-or-equal": _ctx.$t('DataGridFilter.LessOrEqual'),
                "greater-than-or-equal": _ctx.$t('DataGridFilter.GreaterThanOrEqual'),
                between: _ctx.$t('DataGridFilter.Between'),
                "reset-operation-text": _ctx.$t('DataGridFilter.Reset'),
                "starts-with": _ctx.$t('DataGridFilter.StartsWith'),
                "ends-with": _ctx.$t('DataGridFilter.EndsWith'),
                "not-contains": _ctx.$t('DataGridFilter.NotContains')
              }, null, 8, ["equal", "contains", "not-equal", "less-than", "greater-than", "less-than-or-equal", "greater-than-or-equal", "between", "reset-operation-text", "starts-with", "ends-with", "not-contains"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.removeTableHeader)
        ? (_openBlock(), _createBlock(_component_DxGrouping, {
            key: 4,
            "context-menu-enabled": true
          }))
        : _createCommentVNode("", true),
      (!_ctx.removeTableHeader)
        ? (_openBlock(), _createBlock(_component_DxGroupPanel, {
            key: 5,
            visible: true
          }))
        : _createCommentVNode("", true),
      (!_ctx.removeTableHeader)
        ? (_openBlock(), _createBlock(_component_DxGrouping, {
            key: 6,
            "expand-mode": "rowClick"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_DxEditing, {
        "allow-updating": _ctx.allowUpdatingProp,
        mode: "cell"
      }, null, 8, ["allow-updating"]),
      (_ctx.isUsersDevicesSharedToDisplayed)
        ? (_openBlock(), _createBlock(_component_dx_column, {
            key: 7,
            width: 150,
            caption: "Users",
            "cell-template": "usersDeviceIsSharedTo"
          }))
        : _createCommentVNode("", true),
      (_ctx.isUsersRejectApproveShareDisplayed)
        ? (_openBlock(), _createBlock(_component_dx_column, {
            key: 8,
            width: 150,
            caption: "Users",
            "cell-template": "usersRejectApproveShare"
          }))
        : _createCommentVNode("", true),
      (_ctx.isRevokeActionDisplayed)
        ? (_openBlock(), _createBlock(_component_dx_column, {
            key: 9,
            width: 75,
            caption: "Revoke",
            "cell-template": "revokeAction"
          }))
        : _createCommentVNode("", true),
      (_ctx.isRejectApproveActionDisplayed)
        ? (_openBlock(), _createBlock(_component_dx_column, {
            key: 10,
            width: 150,
            caption: "Reject/Approve",
            "cell-template": "rejectApproveAction"
          }))
        : _createCommentVNode("", true),
      (_ctx.showDeviceActions)
        ? (_openBlock(), _createBlock(_component_dx_column, {
            key: 11,
            fixed: true,
            width: 100,
            "cell-template": "deviceActions",
            "fixed-position": "left"
          }))
        : _createCommentVNode("", true),
      (_ctx.assignColumn && _ctx.permissionStore.hasPermission(_ctx.permissions.EditAssignment))
        ? (_openBlock(), _createBlock(_component_dx_column, {
            key: 12,
            caption: _ctx.$t('Sensors.Assign'),
            "cell-template": "assignColumn"
          }, null, 8, ["caption"]))
        : _createCommentVNode("", true),
      (_ctx.spotAssignHistory)
        ? (_openBlock(), _createBlock(_component_dx_column, {
            key: 13,
            caption: _ctx.$t('Sensors.SpotAssignHistory'),
            "cell-template": "spotAssignHistory"
          }, null, 8, ["caption"]))
        : _createCommentVNode("", true),
      (!_ctx.moduleToggleStore.isDevelopment && _ctx.isDevicesTable)
        ? (_openBlock(), _createBlock(_component_dx_column, {
            key: 14,
            width: 150,
            caption: "View details",
            "cell-template": "openViewData"
          }))
        : _createCommentVNode("", true),
      (_ctx.nodesColumn && _ctx.permissionStore.hasPermission(_ctx.permissions.EditAssignment))
        ? (_openBlock(), _createBlock(_component_dx_column, {
            key: 15,
            caption: 'Nodes',
            "cell-template": "manageNodes"
          }))
        : _createCommentVNode("", true),
      (_ctx.deleteWorkOrderColumn && _ctx.permissionStore.hasPermission(_ctx.permissions.DeleteWorkOrder))
        ? (_openBlock(), _createBlock(_component_dx_column, {
            key: 16,
            caption: _ctx.$t("Action.Delete"),
            type: "buttons",
            "cell-template": "deleteWorkOrder"
          }, null, 8, ["caption"]))
        : _createCommentVNode("", true),
      (!_ctx.isActionListNotDisplayed)
        ? (_openBlock(), _createBlock(_component_dx_column, {
            key: 17,
            width: 50,
            "cell-template": "openMenu"
          }))
        : _createCommentVNode("", true),
      (!_ctx.removeTableHeader)
        ? (_openBlock(), _createBlock(_component_dx_column_chooser, {
            key: 18,
            enabled: true,
            mode: "select"
          }))
        : _createCommentVNode("", true),
      (!_ctx.removeTableHeader)
        ? (_openBlock(), _createBlock(_component_dx_export, {
            key: 19,
            "allow-export-selected-data": true,
            enabled: true,
            formats: ['pdf', 'xlsx']
          }, {
            default: _withCtx(() => [
              _createVNode(_component_dx_texts, {
                "export-to": _ctx.$t('ExportHint'),
                "export-all": _ctx.$t('ExportAll') + '{0}',
                "export-selected-rows": _ctx.$t('ExportRows') + '{0}'
              }, null, 8, ["export-to", "export-all", "export-selected-rows"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.removeTableHeader)
        ? (_openBlock(), _createBlock(_component_dx_group_panel, {
            key: 20,
            visible: true,
            "empty-panel-text": _ctx.$t('GroupPanelText')
          }, null, 8, ["empty-panel-text"]))
        : _createCommentVNode("", true),
      (!_ctx.removeTableHeader)
        ? (_openBlock(), _createBlock(_component_dx_search_panel, {
            key: 21,
            text: _ctx.globalSearch,
            "onUpdate:text": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.globalSearch) = $event)),
            visible: true,
            placeholder: _ctx.$t('SearchPlaceholder')
          }, null, 8, ["text", "placeholder"]))
        : _createCommentVNode("", true),
      (!!_ctx.showPerPage)
        ? (_openBlock(), _createBlock(_component_dx_pager, {
            key: 22,
            "show-info": true,
            "show-navigation-buttons": true,
            "show-page-size-selector": true,
            visible: !!_ctx.showPerPage,
            "info-text": _ctx.paggerInfoText
          }, null, 8, ["visible", "info-text"]))
        : _createCommentVNode("", true),
      (!!_ctx.showPerPage)
        ? (_openBlock(), _createBlock(_component_dx_paging, {
            key: 23,
            enabled: !!_ctx.showPerPage,
            "page-size": _ctx.showPerPage
          }, null, 8, ["enabled", "page-size"]))
        : _createCommentVNode("", true),
      (!_ctx.noSelection)
        ? (_openBlock(), _createBlock(_component_dx_selection, {
            key: 24,
            mode: "multiple",
            "show-check-boxes-mode": _ctx.multiselect ? 'onClick' : 'none',
            "select-all-mode": "allPages"
          }, null, 8, ["show-check-boxes-mode"]))
        : _createCommentVNode("", true),
      _createVNode(_component_dx_header_filter, { visible: true }),
      (!_ctx.removeTableHeader)
        ? (_openBlock(), _createBlock(_component_dx_toolbar, { key: 25 }, {
            default: _withCtx(() => [
              _createVNode(_component_dx_item, { name: "groupPanel" }),
              _createVNode(_component_dx_item, {
                options: _ctx.refreshButtonOptions,
                location: "after",
                name: "refreshButton",
                widget: "dxButton"
              }, null, 8, ["options"]),
              _createVNode(_component_dx_item, { name: "columnChooserButton" }),
              _createVNode(_component_dx_item, { name: "exportButton" }),
              _createVNode(_component_dx_item, { name: "searchPanel" })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.renderSummary?.length)
        ? (_openBlock(), _createBlock(_component_DxSummary, { key: 26 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.renderSummary, (summary) => {
                return (_openBlock(), _createBlock(_component_DxTotalItem, {
                  column: summary,
                  "display-format": _ctx.$t('Count') + ': {0}',
                  "summary-type": "count"
                }, null, 8, ["column", "display-format"]))
              }), 256))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["filter-value", "column-auto-width", "data-source", "height", "selected-row-keys", "onExporting", "onSelectionChanged", "onRowPrepared", "onContentReady", "onRowClick", "onCellPrepared", "onEditingStart", "onRowUpdating", "onRowUpdated"]))
}